module.exports = __webpack_public_path__ + "img/redem-certification.b7ab849f.png";